import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveJobMaterial = async (jobMaterial, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      let Payload = {
        jobMaterialID: jobMaterial.jobMaterialID,
        jobID: jobMaterial.jobID,
        materialID: jobMaterial.materialID,
        materialTypeID: jobMaterial.materialTypeID,
        sku: jobMaterial.sku,
        unitID: jobMaterial.unitID,
        budgetedQuantity: jobMaterial.budgetedQuantity,
        budgetedCostPerUnit: jobMaterial.budgetedCostPerUnit,
        budgetedPricePerUnit: jobMaterial.budgetedPricePerUnit,
        actualQuantity: jobMaterial.actualQuantity,
        actualCostPerUnit: jobMaterial.actualCostPerUnit,
        actualPricePerUnit: jobMaterial.actualPricePerUnit,
        providedBy: jobMaterial.providedBy,
        sortOrder: jobMaterial.sortOrder,
        notes: jobMaterial.notes
      };
      const response = await fetch(`${dev_baseUrl}/JobMaterial/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      const data = await response.json();
      if (!response.ok) {
        if (data.statusCode === "Unauthorized") {
          navigate(`/login`);
          return { isError: true, message: 'Unauthorized access' };
        }
        return { isError: true, message: data.message || 'Failed to save material' };
      }
      return data;
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
